/**
 * Development environment configuration
 * Used by default during local development and for the dev Firebase project
 */
export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyBOj6E9c1logepb_3XTO5qyLPo3EhyVv84',
    authDomain: 'adhoc-product-info-dev.firebaseapp.com',
    projectId: 'adhoc-product-info-dev',
    storageBucket: 'adhoc-product-info-dev.firebasestorage.app',
    messagingSenderId: '410142818736',
    appId: '1:410142818736:web:0cdaa179007648e67f9675',
    measurementId: 'G-EL6HKR9PKW',
  },
  allowSeedData: true,
};
